import { useState } from 'react';
import { Calculator, CreditCard, History } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { useCurrentClient } from '@/hooks/useCurrentClient';
import { SplitCalculator } from './SplitCalculator';
import { MachinesList } from './MachinesList';
import { SplitsHistory } from './SplitsHistory';
import { cn } from '@/lib/utils';

type Tab = 'calc' | 'machines' | 'history';

const TABS: Array<{ key: Tab; label: string; icon: typeof Calculator }> = [
  { key: 'calc', label: 'Calculadora', icon: Calculator },
  { key: 'machines', label: 'Maquininhas', icon: CreditCard },
  { key: 'history', label: 'Histórico', icon: History },
];

export function CardSplitsPage() {
  const { clientId, client } = useCurrentClient();
  const [tab, setTab] = useState<Tab>('calc');

  if (!clientId) {
    return (
      <div>
        <h1 className="mb-1 font-brand text-2xl font-bold text-foreground">
          Cartões e antecipação
        </h1>
        <Card>
          <CardContent className="p-12 text-center text-muted-foreground">
            <CreditCard className="mx-auto mb-3 h-10 w-10 opacity-40" />
            <p className="text-sm">Selecione um cliente no topo para gerenciar maquininhas.</p>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="space-y-5">
      <div>
        <h1 className="font-brand text-2xl font-bold text-foreground">Cartões e antecipação</h1>
        <p className="text-sm text-muted-foreground">
          {client?.name ? `${client.name} · ` : ''}calcule líquidos e registre antecipações
        </p>
      </div>

      <div className="flex gap-1 rounded-lg bg-secondary/60 p-1">
        {TABS.map(({ key, label, icon: Icon }) => (
          <button
            key={key}
            onClick={() => setTab(key)}
            className={cn(
              'inline-flex flex-1 items-center justify-center gap-2 rounded-md px-3 py-1.5 text-sm font-medium transition-all',
              tab === key
                ? 'bg-white text-foreground shadow-sm'
                : 'text-muted-foreground hover:text-foreground',
            )}
          >
            <Icon size={14} />
            {label}
          </button>
        ))}
      </div>

      {tab === 'calc' && <SplitCalculator />}
      {tab === 'machines' && <MachinesList />}
      {tab === 'history' && <SplitsHistory />}
    </div>
  );
}
